/**
 * =====================================================
 * Ventura search.js
 * =====================================================
 *
 * Progetto: Ventura Shop
 * Tipo: Satellite JS
 * Dipendenza: main.js (namespace globale "ventura")
 *
 * Descrizione:
 * Questo file contiene tutte le logiche JS specifiche
 * per la pagina dei risultati di ricerca. Si integra con
 * il namespace globale "ventura" definito in main.js.
 *
 * Note:
 * - Non dipendere da altri satelliti, solo da main.js
 * - Il caricamento condizionale avviene tramite la
 *   variabile globale `isTemplate` passata da PHP
 *   tramite WP_PARAMS.is_page_template.
 * - Tutte le funzioni dovrebbero essere incapsulate
 *   all'interno di ventura o di closure locali.
 *
 * Esempio di utilizzo:
 *   ventura.searchFilters();
 *
 * =====================================================
 */
const ventura = window.ventura;
window.isTemplate = window.WP_PARAMS ? window.WP_PARAMS.is_page_template : null;

(function($) {
   if (window.isTemplate !== 'search.php') return; // si avvia solo sul template dei risultati di ricerca

    /**
     * Gestione filtri di ricerca
     */
    ventura.searchFilters = {
        init: function() {
            $('.filter-search__button a').on('click', function(e) {
                e.preventDefault();

                const target = $(this).data('target');

                $('.filter-search__button a').removeClass('is-active');
                $(this).addClass('is-active');

                $('.search-block').hide();
                $('#' + target).show();
            });
        }
    };

    $(document).on('venturaReady', function() {
        ventura.searchFilters.init();
    });
})(jQuery);